import { Typography, Select, MenuItem, FormControl, InputLabel, IconButton } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import styles from './StatusModifier.module.css';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const StatusModifier = ({ putOrder, order }) => {
  const [paymentStatus, setPaymentStatus] = useState('PENDING');
  const [invoiceStatus, setInvoiceStatus] = useState('NO_INVOICE');
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const { t } = useTranslation();

  const handlePaymentStatusModify = () => {
    if (paymentStatus) {
      putOrder({ body: { ...order, status: paymentStatus } });
    }
  };

  const handleInvoiceStatusModify = () => {
    if (invoiceStatus) {
      if (invoiceStatus === 'INVOICED' && (order?.status === 'PAID' || order?.status === 'PENDING')) {
        putOrder({ body: { ...order, invoiceState: invoiceStatus, status: 'INVOICED' } });
      } else {
        putOrder({ body: { ...order, invoiceState: invoiceStatus } });
      }
    }
  };

  useEffect(() => {
    if (order) {
      setPaymentStatus(order?.status || 'PENDING');
      setInvoiceStatus(order?.invoiceState || 'NO_INVOICE');
    }
  }, [order]);

  return (
    <>
      <div className={styles.titleContainer}>
        <Typography className={styles.title}>{t('orderDetails.statusModifier.statusChange')}</Typography>
      </div>
      <div className={styles.orderDetail}>
        <div className={styles.selectContainer}>
          {!shopTier?.onlinePayment && (
            <div className={styles.statusRow}>
              <FormControl className={styles.formControl}>
                <InputLabel className={styles.inputLabel}>{t('orderDetails.statusModifier.orderStatus')}</InputLabel>
                <Select
                  className={styles.statusSelect}
                  value={paymentStatus}
                  onChange={(e) => setPaymentStatus(e.target.value)}>
                  <MenuItem value='PENDING'>{t('orderDetails.statusModifier.pending')}</MenuItem>
                  <MenuItem value='PAID'>{t('orderDetails.statusModifier.paid')}</MenuItem>
                  <MenuItem value='INVOICED'>{t('orderDetails.statusModifier.invoiced')}</MenuItem>
                  <MenuItem value='SHIPPING'>{t('orderDetails.statusModifier.shipping')}</MenuItem>
                  <MenuItem value='DONE'>{t('orderDetails.statusModifier.done')}</MenuItem>
                </Select>
              </FormControl>
              <IconButton
                color='primary'
                onClick={handlePaymentStatusModify}
                disabled={!paymentStatus || paymentStatus === order?.status}
                className={styles.checkButton}>
                <CheckIcon />
              </IconButton>
            </div>
          )}

          <div className={styles.statusRow}>
            <FormControl className={styles.formControl}>
              <InputLabel className={styles.inputLabel}>{t('orderDetails.statusModifier.invoiceStatus')}</InputLabel>
              <Select
                className={styles.statusSelect}
                value={invoiceStatus}
                onChange={(e) => setInvoiceStatus(e.target.value)}>
                <MenuItem value='NO_INVOICE'>{t('orderDetails.statusModifier.noInvoice')}</MenuItem>
                <MenuItem value='INVOICED'>{t('orderDetails.statusModifier.invoice')}</MenuItem>
              </Select>
            </FormControl>
            <IconButton
              color='primary'
              onClick={handleInvoiceStatusModify}
              disabled={!invoiceStatus || invoiceStatus === order?.invoiceState}
              className={styles.checkButton}>
              <CheckIcon />
            </IconButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusModifier;
